import { useEffect } from 'react';
export const useClickOutside = (ref, callBack) => {
  const handleClick = event => {
    // Make sure the document still contains the target element, we occasionally have detached elements that have not been garbage collected.
    // This seems like a memory leak but who knows
    if (ref.current && !ref.current.contains(event.target) && document.contains(event.target)) {
      callBack();
    }
  };
  useEffect(() => {
    if (ref.current) {
      document.addEventListener('click', handleClick);
      return () => {
        document.removeEventListener('click', handleClick);
      };
    }
    return () => {};
  });
};
export default useClickOutside;